import usePayments, { PaymentDetails } from '@order/hooks/usePayments'
import { trpc } from 'api'
import { useEffect } from 'react'
import { usePaymentMethodSettings } from './usePaymentMethods'

const usePaymentStatusPoll = (payment: PaymentDetails, interval = 5000) => {
  const handlePaymentSuccess = usePayments((s) => s.handlePaymentSuccess)

  const settings = usePaymentMethodSettings(payment.method, {
    provider: payment.provider,
  })

  const { data } = trpc.order.payments.status.useQuery(
    {
      payment_id: payment.paymentId || 0,
      provider: payment.provider,
      method: payment.method,
    },
    {
      refetchInterval: interval,
      enabled:
        !!payment.paymentId &&
        payment.status !== 'completed' &&
        settings.updates === 'poll',
    }
  )

  useEffect(() => {
    if (data?.code === 200) {
      handlePaymentSuccess(payment.localId)
      return
    }
  }, [data, handlePaymentSuccess, payment.localId])
}

export default usePaymentStatusPoll
